// AEHSFooter.js
import React from 'react';
import './AEHS.css';
import AnnouncementPopup from '../common/AnnouncementPopup';


const AEHSAnnouncement = () => {
  return (
    <div className="AEHSAnnouncement">
      <div className='AnnTopic'>
        <div style={{width:'20px'}}>
        <img src='https://str4edfdevwebapp.blob.core.windows.net/images/announcementIco.png' alt='annicon' /> 
        </div>
        &emsp;Announcements
      </div>
      <div><AnnouncementPopup /></div>
    </div>
  );
};

export default AEHSAnnouncement;
